import type { CoworldReplayTelemetryContext } from "../frame/replay-telemetry";
import type { GameAddress } from "@softmax/web-addresses";
import { buildHref } from "@softmax/web-addresses";

export function coworldReplayRoute({
  coworldId,
  replayUri,
  telemetryContext,
  options,
}: {
  coworldId: string;
  replayUri: string;
  telemetryContext: CoworldReplayTelemetryContext;
  options?:
    | {
        achievement?: string | null | undefined;
        gameAddress?: GameAddress | null;
      }
    | undefined;
}) {
  const searchParams = new URLSearchParams();
  searchParams.set("replay_uri", replayUri);
  searchParams.set("game", telemetryContext.game ?? "");
  searchParams.set("game_version", telemetryContext.gameVersion ?? "");
  searchParams.set("episode_id", telemetryContext.episodeId);

  // A badge's watch link: the viewer selects the badge's receiving cog
  // (replay-contract param, forwarded to the viewer by CoworldReplayFrame).
  if (options?.achievement) {
    searchParams.set("achievement", options.achievement);
  }

  if (options?.gameAddress) {
    searchParams.set("coworld_id", coworldId);
    return buildHref({
      name: "episodeReplay",
      game: options.gameAddress,
      episodeId: telemetryContext.episodeId,
      search: searchParams,
    });
  }

  return buildHref({ name: "replay", coworldId, search: searchParams });
}
